import { render, staticRenderFns } from "./tab-training.vue?vue&type=template&id=dffbd4be&scoped=true"
import script from "./tab-training.vue?vue&type=script&lang=js"
export * from "./tab-training.vue?vue&type=script&lang=js"
import style0 from "./tab-training.vue?vue&type=style&index=0&id=dffbd4be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dffbd4be",
  null
  
)

export default component.exports